import React from 'react'
import PropTypes from 'prop-types'
import Button from '../buttons/button';

/*
  Toggles between two buttons
 */
var renderButtons = function(buttons, onClick, activeBtt) {

  var key = 0;
  var btns = [];

  buttons.map((data) => {

    if(activeBtt == data.id) {

    }else{

        var offsL = 0;
        if(key > 0)
        {
            offsL = 80;
        }

        btns.push(<Button width="158px" key={key++} text={data.text} icon="layer" onClick={()=>{ onClick(data.id); }} />);
    }

  });

  return btns;
}

const ButtonSwitch = ({ onClick, buttons, activeBtt }) => (
  renderButtons(buttons, onClick, activeBtt)
)

ButtonSwitch.propTypes = {
  onClick: PropTypes.func.isRequired,
  activeBtt: PropTypes.string,
  buttons: PropTypes.array
}

export default ButtonSwitch;



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/buttonToggler/index.js